import type { RatingCategory } from './hooks/useRestaurantRating';

/** Direction of a category-to-category transition in the rating booth. */
export type SwipeDirection = 'left' | 'right';

export const CATEGORY_INFO: Array<{
  category: RatingCategory;
  heading: string;
  icon: string;
  subtitle: string;
}> = [
  { category: 'atmosphere', heading: 'What did you think of the atmosphere?', icon: '🌟', subtitle: 'The vibe, ambiance, and setting' },
  { category: 'service', heading: 'How did you like the service?', icon: '🤝', subtitle: 'Staff friendliness and attentiveness' },
  { category: 'presentation', heading: 'How did you find the presentation?', icon: '🎨', subtitle: 'How the food looked' },
  { category: 'food', heading: 'How did you enjoy the food?', icon: '🍽️', subtitle: 'Taste and quality' },
  { category: 'value', heading: 'How did you perceive the value?', icon: '💰', subtitle: 'Quality for the price' },
  { category: 'overall', heading: 'How did you feel about your overall experience?', icon: '⭐', subtitle: 'Your complete dining experience' },
];

export const CATEGORY_ORDER: RatingCategory[] = CATEGORY_INFO.map((c) => c.category);

/** 6 categories + menu_items + completion */
export const TOTAL_STEPS = CATEGORY_ORDER.length + 2;

export const FOCUS_RING = {
  boxShadow: '0 0 0 2px var(--color-overlay-90), 0 0 0 4px var(--color-primary-purple)',
};

/** Max photos a member may stage per menu item, in both the UI gate and the hook's enforcement. */
export const MAX_PENDING_IMAGES = 3;
